import Model from './Model';

export default class CarType extends Model {
    resource() {
        return 'car-types';
    }
}
